import { useState, useEffect } from 'react';

/**
 * A custom hook to determine whether the current date is after a specified date in the UTC+2 time zone.
 * @returns {boolean} - Returns true if the current date is on or after 01.01.2025 00:00 UTC+2, otherwise false.
 */
// TODO: Remove after 01.01.2025

const useSwitchToNewContent = (): boolean => {
    const [showNewContent, setShowNewContent] = useState<boolean>(false);

    useEffect(() => {
        const getUTCPlus2Time = (date: Date): Date => {
            const utcTimestamp = date.getTime() + date.getTimezoneOffset() * 60 * 1000;
            return new Date(utcTimestamp + 2 * 60 * 60 * 1000);
        };

        const currentDate = getUTCPlus2Time(new Date());
        const switchDate = getUTCPlus2Time(new Date('2025-01-01T00:00:00'));

        setShowNewContent(currentDate >= switchDate);
    }, []);

    return showNewContent;
};

export default useSwitchToNewContent;
